var _effectorFileName = "/src/pages/pair-lessons/index.page.tsx";
import { GetServerSideProps } from 'next';
import { allSettled, fork, serialize } from 'effector';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { pairLessonsPage, PairLessonsPage } from '@/page-content/pair-lessons';
import { DEFAULT_LOCALE } from '@/shared/config/i18n';
import { EFFECTOR_STATE_KEY } from '@/shared/lib/effector';
import { getPageContext } from '@/shared/lib/effector/page';
export const getServerSideProps: GetServerSideProps = async ctx => {
  const scope = fork();
  const locale = ctx.locale ?? DEFAULT_LOCALE;
  await allSettled(pairLessonsPage.open, {
    scope,
    params: getPageContext(ctx)
  });
  return {
    props: {
      [EFFECTOR_STATE_KEY]: serialize(scope),
      ...(await serverSideTranslations(locale, ['common', 'layout-header', 'layout-footer', 'layout-call-to-action', 'pair-lessons-page', 'pair-lessons-main', 'pair-lessons-help-goals', 'pair-lessons-pluses', 'reviews', 'pricing']))
    }
  };
};
export default PairLessonsPage;